import Content from "@/components/Content.tsx";
import {UserRole} from "@/constants.ts";
import Header from "@/Header.tsx";
import {useJwtUser} from "@/JWTAuthProvider.tsx";
import {useSports} from "@/sports/registry.ts";
import {footballPlayer as footballPlayerOf} from "@/onboarding/plays.ts";
import User_ProfileEdit from "@/user/User_ProfileEdit.tsx";
import User_ProfileView_OrganizerDashboard from "@/user/User_ProfileView_OrganizerDashboard.tsx";
import User_ProfileView_PlayerDashboard from "@/user/User_ProfileView_PlayerDashboard.tsx";
import FootballDashboardPage from "@/football/FootballDashboardPage.tsx";
import {createFileRoute, Navigate} from '@tanstack/react-router'
import PlayerProLock from "@/user/PlayerProLock.tsx";
import React from "react";

export const Route = createFileRoute('/_app/profiles/$player_uid/dashboard')({
    component: RouteComponent,
})

function RouteComponent() {
    const user = useJwtUser();
    const userRole = user?.role_override || user?.role;

    // A football player (football and nothing racquet, auth/me's `plays`), with football v2 on,
    // gets their football dashboard. Off: the dashboard everyone had.
    const {data: registry} = useSports();
    const footballPlayer = userRole === UserRole.Player && footballPlayerOf(user, registry);

    // Organizers get the new club dashboard. Old bookmarks and links to this page land there
    // too; only an organizer with no club or community at all still sees the legacy view.
    const dashClubUid = (user as any)?.new_dashboard_club_uid || user?.community?.uid || user?.club?.uid;
    if (userRole === UserRole.Organizer && dashClubUid) {
        return <Navigate to={`/${user?.community?.uid === dashClubUid ? 'communities' : 'clubs'}/${dashClubUid}/dashboard/` as any} replace />;
    }

    return <>
        <Header />
        {/* The player dashboard is a full-width surface; the legacy organizer view keeps the narrow column. */}
        <Content className={userRole === UserRole.Player ? "max-w-[1500px] w-full px-4 pb-6" : ""}>
            {/* The dashboard is Player Pro (allowed_to.view_dashboard): a free player sees the lock
                and the offer, not the figures. Football's own dashboard is not gated. */}
            {userRole === UserRole.Player && (footballPlayer
                ? <FootballDashboardPage />
                : (user?.allowed_to?.view_dashboard ? <User_ProfileView_PlayerDashboard /> : <PlayerProLock what="Your dashboard" />))}
            {userRole === UserRole.Organizer && <User_ProfileView_OrganizerDashboard />}
        </Content>
    </>
}
